<template>
  <v-list class="py-0">
    <v-list-item
      @click="$emit('handleToggleExpandDrawer')"
      :style="{ minHeight: applicationTop + 'px' }"
    >
      <v-list-item-avatar>
        <img :src="photo" :alt="user.name" v-if="photo" />
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title v-if="user.name">{{ user.name }}</v-list-item-title>

        <v-list-item-subtitle v-if="user.email">
          <small>{{ user.email }}</small>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import store from '@/store';

export default {
  computed: {
    user: () => store.getters['authentication/getUser'] || JSON.parse(sessionStorage.getItem('i4pro-portal')).authentication.user,

    photo() {
      if (this.user) return this.user.photo ? this.user.photo : 'static/icon-user.jpg';

      return 'static/icon-user.jpg';
    },

    applicationTop() {
      let vuetify = this.$vuetify;

      if (vuetify) {
        if (vuetify.application) {
          return vuetify.application.top;
        }
      }
      return 0;
    }
  }
};
</script>
